<main>
    <nav id="logoDiv" style="text-align: center;">
      <img src="../../assets/logo1.png" style="max-width: 310px;">
    </nav>
   
    <div>
        <div class="buttons" style="position: absolute;top: 60px;right: 3px;">
            <button  class="Hb1" mat-raised-button (click)="openBottomSheet()">Menu</button>
        </div>
    <router-outlet></router-outlet>
</div>
</main>
